export default "__VITE_ASSET__9f51b95d__"